import React, { useState } from "react";

// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";

// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import { BubbleChart, Search } from "@material-ui/icons";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";

import welcome from "assets/img/undraw_Ordinary_day_re_v5hy.png";
import SearchStudent from "views/dialog/SearchStudent";
import SearchPersonal from "views/dialog/SearchPersonal";

import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";

const useStyles = makeStyles(styles);

export default function Dashboard() {
  const classes = useStyles();

  const [openSearch, setOpenSearch] = useState(false);
  const [openSearchPersonal, setOpenSearchPersonal] = useState(false);

  const handleCloseSearch = () => {
    setOpenSearch(false);
  };

  const handleCloseSearchPersonal = () => {
    setOpenSearchPersonal(false);
  };

  return (
    <div>
      <div className={classes.carDashboard}>
        <GridContainer>
          <GridItem xs={12} md={6}>
            <div className={classes.titleCard}>
              <BubbleChart className={classes.iconTheme} /> Bienvenido(a) al
              panel administrativo
            </div>
            <br></br>
            <br></br>
            <br></br>
            <Card>
              <CardHeader color="success" stats icon>
                <Grid container>
                  <Grid item xs={12} sm={6}>
                    <center>
                      <Button
                        type="submit"
                        className={classes.buttonSubmit}
                        onClick={() => setOpenSearch(true)}
                        startIcon={<Search />}
                      >
                        Buscar ESTUDIANTE
                      </Button>
                    </center>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <center>
                      <Button
                        type="submit"
                        className={classes.buttonSubmit2}
                        onClick={() => setOpenSearchPersonal(true)}
                        startIcon={<Search />}
                      >
                        Buscar PERSONAL
                      </Button>
                    </center>
                  </Grid>
                </Grid>

                <p className={classes.cardCategory}>
                  REALIZAR BUSQUEDA DE FORMA RÁPIDA Y PRECISA
                </p>
              </CardHeader>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={6} style={{ margin: "40px 0" }}>
            <center>
              <img src={welcome} alt="welcome" className={classes.cardImg} />
            </center>
          </GridItem>
        </GridContainer>
        {openSearch ? (
          <SearchStudent open={openSearch} exit={handleCloseSearch} />
        ) : (
          ""
        )}
        {openSearchPersonal ? (
          <SearchPersonal
            open={openSearchPersonal}
            exit={handleCloseSearchPersonal}
          />
        ) : (
          ""
        )}
      </div>
    </div>
  );
}
